module.exports = __webpack_public_path__ + "static/img/banner3.07b8c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner3.png
// module id = 7n2M
// module chunks = 52